<template>
  <div>
    <el-select
      v-model="selectedCity.provinceId"
      placeholder="请选择省份"
      :disabled="disabled"
      :popper-append-to-body="false"
      size="large"
      @change="provinceChanged"
      class="province"
    >
      <el-option
        v-for="item in provinceList"
        :key="item.provinceId"
        :label="item.provinceName"
        :value="item.provinceId"
      ></el-option>
    </el-select>

    <el-select
      v-model="selectedCity.cityId"
      placeholder="请选择城市"
      :popper-append-to-body="false"
      :disabled="!canSelectCity"
      size="large"
      @change="cityChanged"
      class="city"
    >
      <el-option
        v-for="item in cityList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>

    <el-select
      v-model="selectedCity.areaId"
      placeholder="请选择区县"
      :popper-append-to-body="false"
      :disabled="!canSelectCountryList"
      size="large"
      @change="areaChanged"
      class="country"
    >
      <el-option
        v-for="item in countryList"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Object
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  model: {
    prop: "selected",
    event: "change"
  },

  data() {
    return {
      selectedCity: {},
      provinceList: [],
      cityList: [],
      countryList: []
    };
  },

  computed: {
    canSelectCity() {
      return this.selectedCity.provinceId !== "";
    },

    canSelectCountryList() {
      return this.canSelectCity && this.selectedCity.cityId !== "";
    },

    provinceName() {
      const province = this.provinceList.find(
        item => item.provinceId === this.selectedCity.provinceId
      );
      return (province && province.provinceName) || "";
    },

    cityName() {
      const city = this.cityList.find(
        item => item.id === this.selectedCity.cityId
      );
      return (city && city.name) || "";
    },

    areaName() {
      const country = this.countryList.find(
        item => item.id === this.selectedCity.areaId
      );
      return (country && country.name) || "";
    },

    selectedCityDetails() {
      const province = this.provinceList.find(
        item => item.provinceId === this.selectedCity.provinceId
      );

      const city = this.cityList.find(
        item => item.id === this.selectedCity.cityId
      );

      const country = this.countryList.find(
        item => item.id === this.selectedCity.areaId
      );

      return {
        provinceId: province && province.provinceId,
        provinceName: (province && province.provinceName) || "",
        cityId: city && city.id,
        cityName: (city && city.name) || "",
        areaId: country && country.id,
        areaName: (country && country.name) || ""
      };
    }
  },

  created() {
    this.setProvinceList();
  },

  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.selectedCity = this.$lodash.cloneDeep(newValue);
      }
    },

    "selectedCity.provinceId": {
      immediate: true,
      handler: function(newValue) {
        this.setCityList(newValue);
      }
    },

    "selectedCity.cityId": {
      immediate: true,
      handler: function(newValue) {
        this.setCountryList(newValue);
      }
    }
  },

  methods: {
    setProvinceList() {
      this.$api.getAllProvinces().then(res => {
        this.provinceList = res;
      });
    },

    setCityList(id) {
      if (!id) return;
      this.$api.getCitiesByProvinceId(id).then(res => {
        this.cityList = res;
      });
    },

    setCountryList(id) {
      if (!id) return;
      this.$api.getCountiesByCityId(id).then(res => {
        this.countryList = res;
      });
    },

    setSelectedCity(
      provinceId,
      provinceName,
      cityId,
      cityName,
      areaId,
      areaName
    ) {
      this.$emit("change", {
        provinceId,
        cityId,
        areaId,
        provinceName,
        cityName,
        areaName
      });
    },

    provinceChanged(provinceId) {
      this.setSelectedCity(provinceId, this.provinceName, "", "", "", "");
    },

    cityChanged(cityId) {
      this.setSelectedCity(
        this.selectedCity.provinceId,
        this.provinceName,
        cityId,
        this.cityName,
        "",
        ""
      );
    },

    areaChanged(areaId) {
      this.setSelectedCity(
        this.selectedCity.provinceId,
        this.provinceName,
        this.selectedCity.cityId,
        this.cityName,
        areaId,
        this.areaName
      );
    }
  }
};
</script>
